const swiper = new Swiper("#swiper", {
  effect: "fade",

  pagination: {
    el: "#pagination",
    clickable: true,
  },

  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
});
